const ActivityErrorIcon = ({ className, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    fill='none'
    height='20'
    role={title ? 'img' : undefined}
    viewBox='0 0 20 20'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <circle
      cx='10'
      cy='10'
      r='9.25'
      stroke='#FF3152'
      strokeWidth='1.5'
    />
    <path
      d='M10 5V11.5'
      stroke='#FF3152'
      strokeLinecap='round'
      strokeWidth='1.5'
    />
    <circle
      cx='10'
      cy='15'
      fill='#FF3152'
      r='1'
    />
  </svg>
)

export default ActivityErrorIcon
